export default function StepIntro() {
  return (
    <span>
      Clique em{" "}
      <strong style={{ color: "#8142FC" }}>
        Continuar com o Facebook
      </strong>{" "}
      para iniciar o fluxo oficial de cadastro.
    </span>
  );
}
